/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var About = "製品情報";
var Access = "アクセス";
var Account = "アカウント";
var Actions = "アクション";
var Active = "アクティブ";
var Add = "追加";
var Address = "アドレス";
var Advanced = "拡張";
var Aliases = "別名";
var all = "すべて";
var All = "すべて";
var Apply = "適用";
var April = "4 月";
var Arbitrary = "任意";
var Assign = "割り当て";
var August = "8 月";
var Back = "戻る";
var Basic = "基本";
var BNPP_EU = "BNPP_EU";
var Cancel = "キャンセル";
var Category = "カテゴリ";
var Classic = "クラシック";
var Clear = "クリア";
var CLI = "CLI";
var Close = "閉じる";
var Clusters = "クラスター";
var code = "コード";
var Complete = "完了";
var Completed = "完了";
var Compliance = "コンプライアンス";
var Compliant = "準拠";
var Configuration = "構成";
var Configure = "構成";
var Confirm = "確認";
var Connect = "接続";
var Connected = "接続済み";
var Connecting = "接続中";
var Containers = "コンテナ―";
var Country = "国";
var Create = "作成";
var Created = "作成日時";
var Creating = "作成";
var Critical = "重大";
var Current = "現行";
var Custom = "カスタム";
var Dallas = "ダラス";
var Datacenter = "データ・センター";
var Datacenters = "データ・センター";
var December = "12 月";
var Delete = "の削除";
var Deleting = "削除中";
var Deploying = "デプロイ中";
var Disabled = "無効";
var Disconnect = "切断";
var Docs = "文書";
var Documentation = "資料";
var Done = "Done";
var Download = "ダウンロード";
var Draft = "ドラフト";
var Edit = "編集";
var Enabled = "有効";
var Encryption = "暗号化";
var End = "語末";
var Enterprise = "Enterprise";
var Establish = "確立";
var Expired = "期限切れ";
var Failed = "失敗";
var February = "2 月";
var Filter = "フィルター";
var Filters = "フィルター";
var Finalizing = "ファイナライズ中";
var Frankfurt = "フランクフルト";
var Free = "無料";
var Friday = "金曜日";
var Geography = "地域";
var Help = "ヘルプ";
var hour = "時間";
var Hour = "時刻";
var hr = "時間";
var IAM = "IAM";
var ID = "ID";
var Images = "イメージ";
var Inactive = "非アクティブ";
var Incomplete = "不完全な";
var Information = "情報";
var Infrastructure = "インフラストラクチャー";
var Instance = "インスタンス";
var Instances = "インスタンス";
var Integrations = "統合";
var Invalid = "無効";
var January = "1 月";
var July = "7 月";
var June = "6 月";
var Key = "キー";
var Launch = "起動";
var Lite = "ライト";
var Loading = "ロード中";
var Location = "Location";
var Locations = "ロケーション";
var Logging = "ロギング";
var London = "ロンドン";
var March = "3 月";
var May = "5 月";
var Metro = "大都市圏";
var Minute = "分";
var mo = "月";
var Monday = "月曜日";
var Monitoring = "Monitoring";
var Month = "月";
var more = "その他";
var Name = "名前";
var Namespace = "名前空間";
var Namespaces = "名前空間";
var Next = "次へ";
var No = "いいえ";
var None = "なし";
var Normal = "標準";
var Note = "注";
var Notification = "通知";
var November = "11 月";
var Objects = "オブジェクト";
var October = "10 月";
var Off = "Off";
var OK = "OK";
var On = "On";
var Open = "開く";
var Osaka = "大阪";
var Overview = "概要";
var Packages = "パッケージ";
var Pattern = "パターン";
var Pending = "保留中";
var Plan = "プラン";
var Premium = "プレミアム";
var Previous = "前へ";
var Product = "製品";
var Products = "製品";
var Project = "プロジェクト";
var Projects = "プロジェクト";
var Property = "プロパティー (Property)";
var provided = "提供済み";
var Provider = "プロバイダー";
var Provisioning = "プロビジョニング";
var Ready = "準備完了";
var Refresh = "リフレッシュ";
var region = "リージョン";
var Region = "リージョン";
var Remove = "削除";
var Renew = "更新";
var Repositories = "リポジトリー";
var Requested = "要求済み";
var Required = "必須";
var Reservations = "予約";
var Reset = "リセット";
var resources = "resources";
var Resources = "リソース";
var Results = "結果";
var Review = "レビュー";
var Routing = "ルーティング";
var Satellite = "Satellite";
var Saturday = "土曜日";
var Save = "保存";
var Scanning = "スキャン中";
var Schedule = "スケジュール";
var Search = "検索";
var Secret = "シークレット";
var Select = "選択";
var Sending = "送信";
var September = "9 月";
var Serverless = "サーバーレス";
var Service = "サービス";
var Settings = "設定";
var Size = "サイズ";
var Sort = "Sort";
var Source = "ソース";
var Start = "開始";
var State = "状態";
var Status = "ステータス";
var Storage = "ストレージ";
var Submit = "送信";
var Subscription = "サブスクリプション";
var Success = "成功";
var Summary = "要約";
var Sunday = "日曜日";
var Sydney = "シドニー";
var tag = "tag";
var tags = "タグ";
var Tags = "タグ";
var Thursday = "木曜日";
var Tokyo = "東京";
var Topics = "トピック";
var Toronto = "トロント";
var Total = "合計";
var Trash = "ごみ箱";
var Trial = "トライアル";
var Tuesday = "火曜日";
var Unknown = "不明";
var Unsupported = "サポート対象外";
var Update = "更新";
var Upgrade = "アップグレード";
var Value = "値";
var Values = "値";
var Version = "バージョン";
var View = "表示";
var Warning = "警告";
var Wednesday = "水曜日";
var Workloads = "ワークロード";
var Yes = "ある";
var Zone = "ゾーン";
var Zones = "ゾーン";
var ja = {
	"'{{namespace}}' already exists. Enter another name.": "「{{namespace}}」は既に存在します。 別の名前を入力してください。",
	"'Day of week' matches in addition to 'Day of month'": "「曜日」と「日」が一致します。",
	"'Day of week' matches in addition to 'Day of month'. The expression triggers every day.": "「曜日」と「日」が一致します。 式は毎日トリガーされます。",
	"(IAM)": "(IAM)",
	"{{count}} items selected": "{{count}} 項目が選択されました",
	"{{count}} resources": "{{count}} 個のリソース",
	"{{count}} resources included": "{{count}} つのリソースが含まれます",
	"{{current}} of {{total}} pages": "{{current}}/{{total}} ページ",
	"{{datahookName}} response": "{{datahookName}} 応答",
	"{{instance_name}} ( {{region}} )": "{{instance_name}} ( {{region}} )",
	"{{label}} patterns": "{{label}} パターン",
	"{{min}}–{{max}} items": "{{min}}–{{max}} 項目",
	"{{min}}–{{max}} of {{total}} items": "{{min}}–{{max}} 個の項目 (全 {{total}} 個)",
	"{{moduleCount}} modules, {{resourcesCount}} resources": "{{moduleCount}} 個のモジュール、{{resourcesCount}} 個のリソース",
	"{{name}} requires the following option(s) in order to deploy.": "{{name}} を配置するには以下のオプションが必要です。",
	"{{price}} per {{unit}}": "{{unit}} 当たりの {{price}}",
	"{{price}} per month": "1 カ月当たり {{price}}",
	"{{price}}/{{unit}}": "{{price}}/{{unit}}",
	"{{price}}/mo": "{{price}}/mo",
	"{{resourcesCount}} resources": "{{resourcesCount}} つのリソース",
	"{{rolesCount}} Role": "{{rolesCount}} 個の役割",
	"{{rolesCount}} Roles": "{{rolesCount}} 個の役割",
	"{{topicsCount}} topic active for this instance.": "このインスタンスで {{topicsCount}} つのトピックがアクティブです。",
	"{{topicsCount}} topics active for this instance.": "このインスタンスで {{topicsCount}} つのトピックがアクティブです。",
	"{{value}} percent status progress": "{{value}} パーセントの状況進捗率",
	"{{version}} (create a new cluster to try out this beta version)": "{{version}} (このベータ版を試すための新しいクラスターを作成します)",
	"{{version}} (update to an earlier version first)": "{{version}} (最初に、以前のバージョンに更新します)",
	"<span>You must have a Cloud Object Storage instance to create a Satellite location.</span> <a>Learn more.</a>": "<span>Satellite ロケーションを作成するには、クラウド・オブジェクト・ストレージ・インスタンスが必要です。</span> <a>詳細はこちら。</a>",
	"$0.00": "$0.00",
	"$0.00 / instance": "$0.00 / インスタンス",
	"1 item selected": "1 項目が選択されました",
	"1 of 1 page": "1 / 1 ページ",
	"1 role": "1 個の役割",
	"1–1 of 1 item": "1–1 / 1 項目",
	"A collection of keys that belong to your service instance.": "サービス・インスタンスに属する鍵のコレクション。",
	"A key can only have 5 aliases.": "1 つのキーは 5 つのエイリアスを持つことができる。",
	"A Key Protect key": "Key Protect 鍵",
	"A location name is required. ": "ロケーション名が必要です。 ",
	"A multi-tenant key management service. Create and manage cryptographic keys to encrypt data in your applications and control access to your data.": "マルチテナント鍵管理サービス。 アプリケーションのデータを暗号化してデータへのアクセスを制御するための暗号鍵を作成して管理します。",
	"A name is required.": "名前が必要です。",
	"A rotation policy of 12 months is recommended": "12ヶ月のローテーションを推奨",
	"A service to service authorization is required between {{sourceServiceDisplayName}} and {{serviceDisplayName}} to associate the encryption key. Key Protect will create one with your consent. Or you can create one manually.": "暗号鍵を関連付けるために、{{sourceServiceDisplayName}} と {{serviceDisplayName}} の間でサービス間の認証が必要です。 Key Protect はあなたの同意を得て作成します。 あるいは手動で作成することもできる。",
	"A single-tenant key management service. Create and manage cryptographic keys with key vaulting that is provided by dedicated customer-controlled Hardware Security Module. ": "シングルテナント鍵管理サービス。 お客様管理の専用のハードウェア・セキュリティー・モジュールによって提供される鍵ボールトを使用して、暗号鍵を作成して管理します。 ",
	"A tag can include only alphanumeric characters, spaces, underscores, dashes, periods and one colon.": "タグに使用できるのは、英数字、スペース、下線、ダッシュ、ピリオド、および 1 つのコロンのみです。",
	"A tag cannot end with a colon.": "タグの末尾をコロンにすることはできません。",
	"A tag cannot include more than 128 characters.": "タグに使用できる文字数は 128 以下です。",
	"A tag cannot start with a colon.": "タグの先頭をコロンにすることはできません。",
	"A tag should not have spaces around a colon.": "タグでは、コロンをスペースで囲むことはできません。",
	About: About,
	Access: Access,
	"Access management tags": "アクセス管理タグ",
	"Access management tags (optional)": "アクセス管理タグ (オプション)",
	"Access management tags help you apply flexible access policies on specific resources.": "アクセス管理タグを使用すると、特定のリソースに柔軟なアクセス・ポリシーを適用できます。",
	Account: Account,
	"Account type": "アカウント・タイプ",
	"Action required": "必要なアクション",
	Actions: Actions,
	Active: Active,
	"Active promotions": "アクティブ・プロモーション",
	"Activity tracker event collection is enabled for this resource and sent to targets as defined by your routing configuration.": "アクティビティトラッカーのイベント収集がこのリソースに対して有効になり、ルーティング設定によって定義されたターゲットに送信されます。",
	"Activity tracker events": "Activity Tracker イベント",
	"Activity tracking": "アクティビティー・トラッキング",
	Add: Add,
	"Add a single namespace or multiple namespaces to your specific namespace's list.": "特定の名前空間のリストに 1 つ以上の名前空間を追加します。",
	"Add a single project or multiple projects to your specific project's list.": "特定のプロジェクトのリストに 1 つ以上のプロジェクトを追加します。",
	"Add Activity tracker event collection": "アクティビティ・トラッカー・イベント・コレクションの追加",
	"Add activity tracking": "アクティビティトラッキングの追加",
	"Add event collection": "イベントコレクションの追加",
	"Add hosts": "ホストの追加",
	"Add hosts to meet the minimum service requirements.": "最小サービス要件を満たすようにホストを追加してください。",
	"Add key alias (optional)": "鍵のエイリアスの追加（オプション）",
	"Add key description (optional)": "キーの説明を追加する（オプション）",
	"Add logging": "ロギングの追加",
	"Add monitoring": "モニタリングの追加",
	"Add namespace": "名前空間の追加",
	"Add New": "新規の追加",
	"Add project": "プロジェクトの追加",
	"Add storage": "ストレージの追加",
	"Add tags": "タグの追加",
	"Add to estimate": "見積もりに追加",
	"Add to existing": "既存に追加",
	"Add to project": "プロジェクトに追加",
	"Adding ...": "追加中 ...",
	Address: Address,
	"Address any required actions below to successfully provision your service. You can complete these steps now, or after creating the service.": "サービスを正常にプロビジョンするには、以下の必要なアクションに対処してください。 これらのステップは、ここで実行することも、サービスの作成後に実行することもできます。",
	"Address field": "アドレス・フィールド",
	Advanced: Advanced,
	"Advanced options": "詳細オプション",
	"After connection": "接続後",
	"After the service cluster is created, assign storage to the cluster.": "サービス・クラスターが作成されたら、クラスターにストレージを割り当てます。",
	"After you disconnect Event Notifications, the {{serviceName}} instance is removed from the list of source services in the Event Notifications instance.": "Event Notifications を切断すると、{{serviceName}} インスタンスは Event Notifications インスタンスのソース・サービスのリストから削除されます。",
	Aliases: Aliases,
	"Aliases may only contain alphanumeric characters and -_.": "エイリアスには英数字と「-_」のみを含めることができます。",
	"Aliases must be at least 2 characters and at most 90 characters.": "エイリアスは 2 文字以上 90 文字以内でなければならない。",
	all: all,
	All: All,
	"All audit events (default target)": "すべての監査イベント（デフォルト・ターゲット）",
	"All audit events from your account will be sent to a new instance": "アカウントからのすべての監査イベントが新しいインスタンスに送信されます",
	"All audit events from your account will be sent to an existing instance": "アカウントからのすべての監査イベントは、既存のインスタンスに送信されます",
	"All namespaces": "すべての名前空間",
	"All namespaces not supported": "すべての名前空間がサポートされない",
	"All platform logs": "すべてのプラットフォームログ",
	"All prerequisite services are installed on the location.": "すべての前提条件サービスがこのロケーションにインストールされます。",
	"All projects": "すべてのプロジェクト",
	"All projects not supported": "すべてのプロジェクトがサポートされない",
	"All regions": "すべての地域",
	"All resource groups": "すべてのリソース・グループ",
	"All secret groups": "すべてのシークレット・グループ",
	"All types": "すべてのタイプ",
	"All zone names must be unique": "すべてのゾーン名は固有でなければなりません",
	"Allowed actions for the {{roleName}} role ({{actionCount}})": "{{roleName}} 役割 ({{actionCount}}) に許可されたアクション",
	"Already have an account? <a>Log in</a>": "既にアカウントをお持ちの場合 <a>ログイン</a>",
	"An error occurred when fetching secrets. Try again later.": "シークレットの取得中にエラーが発生しました。 後でもう一度試してください。",
	"An instance of Event Notifications <a>Create new instance</a>": "イベント通知 <a>新規インスタンスの作成</a> のインスタンス",
	"An unexpected error occurred.": "予期しないエラーが発生しました。",
	"Analyze and manage logs for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "問題を迅速に解決し、ダウンタイムを未然に防ぐためにログを分析・管理します。 <a>詳細はこちら</a>",
	Apply: Apply,
	"Apply a code": "コードの適用",
	April: April,
	Arbitrary: Arbitrary,
	"Are you sure that you want to disconnect {{serviceName}} instance from the \"{{ENInstanceName}}\" instance?": "{{serviceName}} インスタンスを「{{ENInstanceName}}」インスタンスから切り離したいということでよろしいでしょうか？",
	"Are you sure you want to close the side panel?": "サイド・パネルを閉じてもよろしいですか?",
	"Are you sure you want to close this panel? Any selections you have made will be lost.": "このパネルを閉じますか? 選択した内容はすべて失われる。",
	"Are you sure?": "よろしいですか?",
	Assign: Assign,
	"Associate key": "鍵の関連付け",
	"Attachment name": "接続名",
	"Audit event collection is already enabled for this resource": "このリソースでは、監査イベントの収集がすでに有効になっています",
	"Audit event collection is recommended for optimal troubleshooting and reducing downtime": "監査イベントの収集は、最適なトラブルシューティングとダウンタイムの削減のために推奨されます",
	"Audit events (error)": "監査イベント（エラー）",
	"Audit events from {{region}} will be sent to a new instance": "{{region}} からの監査イベントは、新しいインスタンスに送られます",
	"Audit events from {{region}} will be sent to an existing instance": "{{region}} からの監査イベントは、既存のインスタンスに送信されます",
	"Audit events in {{region}}": "{{region}} の監査イベント",
	"Audit events will be collected from enabled IBM Cloud services according to the defined routing scope.": "監査イベントは、定義されたルーティング・スコープに従って、有効な IBM Cloud サービスから収集されます。",
	"Audit events...": "監査イベント...",
	August: August,
	"Authentication is required or you do not have the correct permissions to perform this action.": "認証が必要であるか、ユーザーにこのアクションを実行するための正しいアクセス権がありません。",
	"Authorization error": "許可エラー",
	"Authorization met": "許可が満たされています",
	"Authorization needed": "許可が必要です",
	"Authorize now": "今すぐ許可",
	"Authorizing...": "認可...",
	Back: Back,
	"Base URI": "ベースURI",
	"Base64 encoded key material": "Base64 でエンコードされたキー素材",
	Basic: Basic,
	"Before you begin": "開始前に",
	"Before your project can validate or deploy configurations, the Projects service needs to be authorized in this account to communicate with Schematics, Catalog Management, Secrets Manager, and Resource Controller. A user with the required access to those services can automatically grant authorizations by creating a project in this account, or they can create the service to service authorizations manually. This authorization is only required once.": "プロジェクトが構成を検証またはデプロイできるようにするには、Schematics、カタログ管理、Secrets Manager、およびリソース・コントローラーと通信するために、プロジェクト・サービスがこのアカウントで許可されている必要があります。 これらのサービスへの必要なアクセス権限を持つユーザーは、このアカウントでプロジェクトを作成することによって許可を自動的に付与することも、サービス間許可を手動で作成することもできます。 この権限が必要なのは 1 回のみです。",
	"Billing information": "課金情報",
	"Billing period": "請求対象期間",
	BNPP_EU: BNPP_EU,
	"Bucket name": "バケット名",
	"By {{name}}": "{{name}} まで",
	"By clicking Save, you are creating the following access:": "「保存」をクリックすると、以下のアクセス権限が作成されます。",
	"Can't retrieve details": "詳細を取得できない",
	Cancel: Cancel,
	"Cannot list integrations!": "統合をリストできません。",
	"Cannot view keys in this instance": "このインスタンスでは鍵を表示できません",
	Category: Category,
	"Charges apply. <a>Learn more</a>": "料金が適用されます。 <a>詳細はこちら</a>",
	"Choose a cluster version": "クラスター・バージョンを選択する",
	"Choose a key ring": "鍵リングの選択",
	"Choose a resource group": "リソース・グループの選択",
	"Choose account...": "アカウントの選択...",
	"Choose an existing HPCS instance.": "既存の HPCS インスタンスを選択します。",
	"Choose an existing Key Protect instance.": "既存の Key Protect インスタンスを選択します。",
	"Choose an instance": "インスタンスの選択",
	"Choose an option": "オプションの選択",
	"Choose category...": "カテゴリーの選択...",
	"Choose location": "ロケーションの選択",
	"Choose plan": "プランの選択",
	"Choose property...": "プロパティーの選択...",
	"Choose provider...": "プロバイダーの選択...",
	"Choose secret...": "シークレットの選択...",
	"Choose service instance...": "サービス・インスタンスの選択...",
	"Choose source name...": "ソース名の選択...",
	"Choose source...": "ソースの選択...",
	"Choose which IBM Cloud Monitoring instance will receive platform metrics from enabled service instances across IBM Cloud.": "IBM Cloud の対応サービス・インスタンスからプラットフォーム・メトリックを受け取る IBM Cloud Monitoring インスタンスを選択します。",
	"Choose which IBM Log Analysis instance will receive platform logs from enabled service instances across IBM Cloud.": "IBM Cloud の対応サービス・インスタンスからプラットフォーム・ログを受け取る IBM Log Analysis インスタンスを選択します。",
	Classic: Classic,
	Clear: Clear,
	"Clear all": "すべてクリア",
	"Clear all selected items": "選択済みの項目をすべてクリア",
	"Clear filters": "フィルターをクリア",
	"Clear selected": "選択のクリア",
	"Clear selected item": "選択済みの項目をクリア",
	"Clear selection": "選択をクリア",
	CLI: CLI,
	Close: Close,
	"Close menu": "メニューを閉じる",
	"Close page navigation menu": "ページ・ナビゲーション・メニューを閉じる",
	"Close Panel": "パネルを閉じる",
	"Close Push Panel": "プッシュ・パネルを閉じる",
	"Closing side panel": "サイド・パネルを閉じる",
	"Cloud Logs": "クラウド・ログ",
	"Cloud Logs instance": "クラウド・ログ・インスタンス",
	"Cloud Logs instance name": "クラウドログのインスタンス名",
	"Cloud Object Storage": "Cloud Object Storage",
	"Cloud Object Storage instance": "Cloud Object Storage インスタンス",
	"Cluster \"{{name}}\" is being deleted.": "クラスタ「{{name}}」が削除されました。",
	"Cluster management": "クラスター管理",
	"Cluster version": "クラスター・バージョン",
	"Cluster version cannot be updated.": "クラスター・バージョンを更新できません。",
	Clusters: Clusters,
	code: code,
	"Code sample": "コード・サンプル",
	"Collapse all rows": "すべての行を省略",
	"Collapse group": "グループの省略",
	"Collapse row": "行を省略",
	"Collapse summary": "要約の省略表示",
	"Compact (24px)": "最低 (24px)",
	Complete: Complete,
	Completed: Completed,
	Compliance: Compliance,
	Compliant: Compliant,
	Configuration: Configuration,
	"Configuration details": "構成の詳細",
	"Configuration name": "構成名",
	Configure: Configure,
	"Configure activity tracking": "アクティビティトラッキングの設定",
	"Configure encryption": "暗号化の構成",
	"Configure logging": "ロギングの構成",
	"Configure monitoring": "モニタリングの構成",
	Confirm: Confirm,
	Connect: Connect,
	"Connect to Event Notifications": "Event Notifications に接続",
	"Connect your {{serviceName}} instance to an existing Event Notifications instance.": "{{serviceName}} インスタンスを既存の Event Notifications インスタンスに接続します。",
	Connected: Connected,
	"Connected instance": "接続されたインスタンス",
	"Connected instance of Event Notifications does not exist. Contact your administrator.": "接続されているEvent Notificationsのインスタンスが存在しません。 管理者に問い合わせてください。",
	Connecting: Connecting,
	"Contact your account administrator to access a plan to provision Key Protect.": "アカウント管理者に連絡して、Key Protect をプロビジョンするためのプランにアクセスしてください。",
	"Contact your account administrator to access a resource group to provision Key Protect.": "アカウント管理者に連絡して、Key Protect をプロビジョンするためのリソース・グループにアクセスしてください。",
	"Contact your administrator for access.": "アクセス権限については、管理者に問い合わせてください。",
	"Contact your administrator for additional assistance.": "さらに支援が必要な場合は、管理者にお問い合わせください。",
	"Container registry": "Container registry",
	Containers: Containers,
	"Copied to clipboard": "クリップボードにコピーしました",
	"Copy to clipboard": "クリップボードにコピー",
	"Cost details": "コストの詳細",
	"costctr:124": "costctr:124",
	"Could not load pricing information. Refresh the page or try again later.": "価格設定情報をロードできませんでした。 ページを最新表示するか、後で再試行してください。",
	Country: Country,
	Create: Create,
	"Create a key": "鍵の作成",
	"Create a Logs routing target to support log management and analysis for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "ログ・ルーティング・ターゲットを作成し、ログ管理と分析をサポートすることで、迅速な問題解決と事前のダウンタイム防止を実現します。 <a>詳細はこちら</a>",
	"Create a new instance to get started.": "新しいインスタンスを作成して開始する。",
	"Create a project": "プロジェクトの作成",
	"Create a Satellite location to bring IBM Cloud anywhere. For more information, <a>see the documentation.</a>": "Satelliteロケーションを作成し、IBM Cloudを任意の場所に配置します。 詳細については、<a>資料を参照</a>してください。",
	"Create an Activity tracker event routing target and route to support monitoring and auditing IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "セキュリティとコンプライアンスを強化するために、IBM Cloud アクティビティの監視と監査をサポートするアクティビティ・トラッカー・イベント・ルーティング・ターゲットとルートを作成します。 <a>詳細はこちら</a>",
	"Create an encryption key or import your own key.": "暗号化キーを作成するか、独自のキーをインポートします。",
	"Create cluster": "クラスターの作成",
	"Create failed": "作成失敗",
	"Create instance": "インスタンスの作成",
	"Create location": "ロケーションの作成",
	"Create new": "新規作成",
	"Create new instance": "新規インスタンスの作成",
	"Create new key": "新しい鍵の作成",
	"Create new secret": "新規シークレットの作成",
	"Create reference": "参照の作成",
	"Create resource": "リソースの作成",
	"Create Satellite location": "Satelliteロケーションの作成",
	"Create secret": "秘密の作成",
	"Create services": "サービスの作成",
	"Create Topics, Destinations and Subscriptions in Event Notifications to be notified of events that are generated by your {{serviceName}}": "Event Notifications でトピック、宛先、サブスクリプションを作成し、{{serviceName}} で生成されたイベントを通知します",
	Created: Created,
	Creating: Creating,
	"Creating ...": "作成しています...",
	"Creating...": "作成中...",
	Critical: Critical,
	"CRON expression": "Cron式",
	Current: Current,
	Custom: Custom,
	"Custom access": "カスタム・アクセス",
	Dallas: Dallas,
	"dashlet.title": "dashlet.title",
	Datacenter: Datacenter,
	Datacenters: Datacenters,
	"Datahook argument block": "Datahook引数ブロック",
	"Datahook Params": "Datahookパラメーター",
	"Datahook response": "Datahook応答",
	"Day of month": "日",
	"Day of Month (UTC)": "日(UTC)",
	"Day of week": "曜日",
	"Day of week (UTC)": "曜日(UTC)",
	December: December,
	"Dedicated hosts": "専用ホスト",
	"Default target": "デフォルト・ターゲット",
	"Default title": "デフォルト・タイトル",
	"Define project details": "プロジェクトの詳細を定義",
	"Define the recurring timings of the events generated by this event. Select a predefined pattern and customize it to your needs. Schedules are specified in Coordinated Universal Time (UTC).": "このイベントによって生成されるイベントの繰り返しのタイミングを定義します。 事前定義パターンを選択し、必要に応じてカスタマイズします。 スケジュールは協定世界時(UTC)で指定されます。",
	"Define the scope of audit events collected": "収集する監査イベントの範囲を定義する",
	Delete: Delete,
	"Delete cluster": "クラスターの削除",
	"Delete failed": "削除失敗",
	"Delete retry wait": "削除再試行の待機",
	"Delete the persistent storage used by this cluster": "このクラスターで使用される永続ストレージの削除",
	Deleting: Deleting,
	"Deleting...": "削除中...",
	"Deploy failed": "Deploy failed",
	"Deploy retry wait": "デプロイ再試行の待機",
	Deploying: Deploying,
	"Deployment ready": "デプロイメント準備完了",
	"Deprecated version, support will end {{when}}. Update the version to continue to receive support.": "推奨されないバージョンであり、サポートは {{when}} で終了します。 サポートを続行するには、このバージョンを更新してください。",
	"Description (optional)": "説明（オプション）",
	"Description of the source": "ソースの説明",
	Disabled: Disabled,
	Disconnect: Disconnect,
	"Disconnect Event Notifications": "Event Notifications の切断",
	"DNS subdomain labels must be no more than {{maxLength}} characters.": "DNSサブドメイン・ラベルは {{maxLength}} 文字以内でなければなりません。",
	Docs: Docs,
	Documentation: Documentation,
	Done: Done,
	"Done editing": "編集の完了",
	Download: Download,
	Draft: Draft,
	"During the update, your cluster master, worker nodes, apps, and resources continue to run. After the update is complete, you can update your worker node versions. For instructions and more information about differences across versions, <a>review the docs</a>.": "更新中も、クラスター・マスター、ワーカー・ノード、アプリ、およびリソースは継続して実行されます。 更新が完了したら、ワーカー・ノードのバージョンを更新できます。 手順およびバージョン間の相違点について詳しくは、<a>資料を確認</a>してください。",
	Edit: Edit,
	"Edit activity tracker integration": "アクティビティトラッカーの統合を編集する",
	"Edit Array": "配列の編集",
	"Edit columns": "列の編集",
	"Edit configuration": "構成の編集",
	"Edit details": "詳細の編集",
	"Edit JSON": "JSON を編集する",
	"Edit logging integration": "編集ログの統合",
	"Edit secure value": "セキュアな値の編集",
	"Edit tags": "タグの編集",
	"Enable lifecycle notifications for your {{serviceName}} instance by connecting an Event Notifications service instance.": "Event Notificationsサービス・インスタンスを接続することにより、 {{serviceName}} インスタンスのライフサイクル通知が有効になります。",
	Enabled: Enabled,
	"Enables supervision, compliance, and audits the operations and risk to manage your IBM Cloud account.": "IBM Cloud アカウントの管理のために、監視とコンプライアンスの徹底を実現し、運用状況とリスクを監査します。",
	Encryption: Encryption,
	"Encryption key associated": "関連付けられた暗号鍵",
	"Encryption options menu": "暗号化オプションメニュー",
	End: End,
	"End date": "終了日",
	"Enhance your Schematics experience with integrations. Start adding integrations today by selecting from one of the options below.": "統合により Schematics のエクスペリエンスを向上させます。 以下のいずれかのオプションを選択して、さっそく統合の追加を開始しましょう。",
	"Enter a name for the configuration of the deployable architecture.  For example: production-vpc": "デプロイ可能アーキテクチャーの構成の名前を入力します。  例: production-vpc",
	"Enter a password": "パスワードを入力してください",
	"Enter a valid CRN": "有効な CRN を入力してください",
	"Enter array values. Quotations are added to values after you save.": "配列値を入力します。 保存すると、引用符が値に追加されます。",
	"Enter name and description": "名前と説明を入力してください",
	"Enter names for the host zones. For high availability, allocate your hosts across these three zones based on your infrastructure provider zones. <a>Why do I need zones?</a>": "ホスト・ゾーンの名前を入力します。 高可用性を実現するためには、インフラストラクチャー・プロバイダー・ゾーンに基づいてこれら 3 つのゾーンでホストを割り振ります。 <a>ゾーンが必要な理由</a>",
	"Enter namespaces separated by a comma. After you click Add, the new namespaces are included in the list and automatically selected.": "名前空間をコンマで区切って入力します。 「追加」をクリックすると、新しい名前空間がリストに追加され、自動的に選択されます。",
	"Enter projects separated by a comma. After you click Add, the new projects are included in the list and automatically selected.": "プロジェクトをコンマで区切って入力します。 「追加」をクリックすると、新しいプロジェクトがリストに追加され、自動的に選択されます。",
	"Enter source name": "ソース名を入力する",
	"Enter the exact name of an existing bucket in your Cloud Object Storage instance. If no name is provided, a new bucket is created for you.": "クラウド・オブジェクト・ストレージ・インスタンスで既存のバケットの正確な名前を入力します。 名前を指定しない場合、ユーザー用に新規バケットが作成されます。",
	Enterprise: Enterprise,
	"Entire secret": "シークレット全体",
	"Environment (optional)": "環境 (オプション)",
	"Environments can contain properties that are shared across related configurations. Within the configuration, you can override any values that are provided by the environment. <a>Learn more</a>": "環境には、関連する構成間で共有されるプロパティーを含めることができます。 構成内で、環境によって提供されるすべての値をオーバーライドできます。 <a>詳細はこちら</a>",
	"Error": "エラー",
	"Error checking existing services status": "既存のサービス状況の検査中にエラーが発生しました",
	"Error checking host status": "ホスト状況の検査中にエラーが発生しました",
	"Error checking storage status": "ストレージ状況の検査中にエラーが発生しました",
	"Error fetching tags": "タグの取り出し中にエラーが発生しました",
	"Error icon": "エラー・アイコン",
	"Error loading accounts": "アカウントのロード中のエラー",
	"Error loading categories": "カテゴリーのロード中のエラー",
	"Error loading groups": "グループのロード中のエラー",
	"Error loading instances": "インスタンスのロード中のエラー",
	"Error loading keys": "キーのロード中のエラー",
	"Error loading pricing": "価格設定のロード・エラー",
	"Error loading properties": "プロパティーのロード中のエラー",
	"Error loading providers": "プロバイダーのロード中のエラー",
	"Error loading regions": "リージョンのロード中のエラー",
	"Error loading resource groups": "リソース・グループのロード・エラー",
	"Error loading S2S auth": "S2S 認証のロード中にエラーが発生しました",
	"Error loading secrets": "シークレットのロード中のエラー",
	"Error loading source names": "ソース名のロード中のエラー",
	"Error loading sources": "ソースのロード中のエラー",
	"Error loading types": "タイプのロード中のエラー",
	"Error validating this code. Please make sure you don't include any quotation marks in the promo code.": "このコードの検証中にエラーが発生しました。 プロモーション・コードに引用符が含まれていないことを確認してください。",
	Establish: Establish,
	"Estimate costs": "見積もりのコスト",
	"Estimated cost per instance": "インスタンス当たりの見積もりコスト",
	"Estimated starting cost": "開始コスト見積",
	"Estimated total ({{count}} instances)": "見積もり合計 ({{count}} 個のインスタンス)",
	"Event Notifications": "Event Notifications",
	"Event Notifications instance": "Event Notifications のインスタンス",
	"Event Notifications service instance": "Event Notifications サービス・インスタンス",
	"Event Source Manager": "Event Source Manager",
	"Every 2 hours": "2 時間毎",
	"Every 2 minutes": "2分ごと",
	"Every 3 hours": "3時間ごと",
	"Every 4 hours": "4 時間毎",
	"Every 5 minutes": "5分ごと",
	"Every 6 hours": "6時間ごと",
	"Every 10 minutes": "10分ごと",
	"Every 15 minutes": "15 分ごと",
	"Every day": "毎日",
	"Every fifth day": "5 日ごと",
	"Every fourth day": "4 日ごと",
	"Every fourth month": "4カ月ごと",
	"Every hour": "毎時",
	"Every minute": "1分ごと",
	"Every month": "毎月",
	"Every second day": "2日ごと",
	"Every second month": "2カ月ごと",
	"Every sixth month": "6カ月ごと",
	"Every third day": "3 日ごと",
	"Every third month": "3カ月ごと",
	"Examples: access:dev, proj:version-1": "例: access:dev, proj:version-1",
	"Examples: env:dev, version-1": "例: env:dev, version-1",
	"Existing instance": "既存のインスタンス",
	"Exiting encryption selection": "暗号化選択の終了",
	"Expand all rows": "すべての行を展開",
	"Expand group": "グループの展開",
	"Expand row": "行を展開",
	"Expand summary": "要約の展開",
	Expired: Expired,
	"Expired (beta)": "有効期限切れ (ベータ版)",
	"Expires {{when}}": "{{when}} に有効期限切れ",
	"Expires after beta": "ベータ版の後に有効期限切れ",
	"Extra large (64px)": "特大(64px)",
	"Extra small (24px)": "極小(24px)",
	Failed: Failed,
	"Failed to check permission": "パーミッションのチェックに失敗",
	"Failed to create configuration": "設定の作成に失敗しました",
	"Failed to create key": "鍵の作成の失敗",
	"Failed to create policy": "ポリシーの作成に失敗しました",
	"Failed to create project": "プロジェクトの作成に失敗しました",
	"Failed to fetch": "取得に失敗しました",
	"Failed to fetch IBM Cloud Activity Tracker instances.": "IBM Cloud Activity Tracker インスタンスの取得に失敗しました。",
	"Failed to fetch IBM Cloud Monitoring instances.": "IBM Cloud Monitoring インスタンスの取得に失敗しました。",
	"Failed to fetch IBM Log Analysis instances.": "IBM Log Analysis インスタンスの取得に失敗しました。",
	"failure state": "障害状態",
	February: February,
	"Fetch data": "データの取り出し",
	Filter: Filter,
	"Filter instance by region": "リージョンでインスタンスをフィルター",
	"Filter...": "フィルター...",
	Filters: Filters,
	"Filters:": "フィルター:",
	Finalizing: Finalizing,
	"Finalizing cluster...": "クラスターのファイナライズ中 ...",
	"Finalizing workers...": "ワーカーのファイナライズ中...",
	Frankfurt: Frankfurt,
	Free: Free,
	Friday: Friday,
	Geography: Geography,
	"Get operational visibility into your Cloud resources with IBM Cloud Activity Tracker.": "IBM Cloud Activity Tracker を使用して、Cloud のリソースを運用のために可視化できます。",
	"Get operational visibility into your Cloud resources with IBM Cloud Monitoring.": "IBM Cloud Monitoring により、Cloud リソースの運用の可視化が可能になります。",
	"Get operational visibility into your Cloud resources with IBM Log Analysis.": "IBM Log Analysis により、Cloud リソースの運用の可視化が可能になります。",
	"Get started": "使用を開始する",
	"Get started with Security and Compliance Center": "Security and Compliance Centerを使用する",
	"Give your key an alias for easy retrieval later.": "後で簡単に検索できるように、キーに別名を付けましょう。",
	"Helm catalog": "Helmカタログ",
	Help: Help,
	"Hide password": "パスワードを非表示にする",
	"Host usage\n(used / total)": "ホストの使用率 (使用中/合計)",
	"Hosts needed": "必要なホスト数",
	"Hosts requirements met": "ホスト要件が満たされています",
	hour: hour,
	Hour: Hour,
	"Hour (UTC)": "時刻(UTC)",
	hr: hr,
	"Hyper Protect Crypto Services": "Hyper Protect Crypto Services",
	"I agree to use my token to create a service to service policy between source service {{sourceServiceDisplayName}} and target service {{serviceDisplayName}} on my behalf.": "私のトークンを使用して、ソースサービス{{sourceServiceDisplayName}}とターゲット・サービス{{serviceDisplayName}}間のサービス間ポリシーを作成することに同意します。",
	"I confirm that I want to stop receiving platform logs from {{instance}}": "{{instance}} からのプラットフォーム・ログの受信停止を要請します",
	"I confirm that I want to stop receiving platform metrics from {{instance}}": "{{instance}} からのプラットフォーム・メトリックの受信停止を要請します",
	"IaaS ready": "IaaS 対応",
	IAM: IAM,
	"IAM credentials": "IAM 資格情報",
	"IBM Cloud": "IBM Cloud",
	"IBM Cloud Activity Tracker": "IBM Cloud Activity Tracker",
	"IBM Cloud Monitoring": "IBM Cloud Monitoring",
	"IBM Cloud Satellite": "IBM Cloud Satellite",
	"IBM Log Analysis": "IBM Log Analysis",
	ID: ID,
	"ID: {{incidentId}}": "ID: {{incidentId}}",
	"If no key ring is assigned, key will be added to the default key ring.": "鍵リングが割り当てられていない場合、鍵はデフォルトの鍵リングに追加されます。",
	"If selected, the array will be saved as \"__NOT_SET__\" string.": "選択した場合、配列は「__NOT_SET__」ストリングとして保存されます。",
	"If the initial value was not a valid string array, an empty or single item array will appear below.": "初期値が有効なストリング配列でなかった場合は、空または単一項目の配列が下に表示されます。",
	"If your user tags are billing related, consider writing tags as key:value pairs, such as": "ユーザー・タグが請求処理に関係する場合は、以下のように「キー:値」のペアとしてタグを記述することを検討してください。",
	Images: Images,
	"Import your own key": "自分の鍵のインポート",
	"In progress": "進行中",
	"in progress state": "進行中状態",
	Inactive: Inactive,
	"inactive state": "非アクティブ状態",
	Incomplete: Incomplete,
	"incomplete state": "不完全な状態",
	Information: Information,
	"information state": "情報状態",
	Infrastructure: Infrastructure,
	"Infrastructure zones": "インフラストラクチャー・ゾーン",
	Instance: Instance,
	"Instance ID": "インスタンス ID",
	"Instance location": "インスタンス・ロケーション",
	"Instance name": "インスタンス名",
	"Instance(s) in {{region}}": "{{region}} のインスタンス",
	"Instance(s) in region": "リージョン内のインスタンス",
	Instances: Instances,
	Integrations: Integrations,
	"Internal server error. Wait a minute and try your action again. If the issue persists, open a support ticket.": "内部サーバー・エラー。 しばらく待ってから、操作を再試行してください。 問題が解決しない場合は、サポート・チケットをオープンしてください。",
	"Interpolated URI": "補間されたURI",
	Invalid: Invalid,
	"Invalid datahook object, using last valid options": "前回の有効なオプションを使用しているDatahookオブジェクトは無効です",
	"Invalid label name.": "ラベル名が無効です。",
	"Invalid label prefix or name.": "ラベルの接頭部または名前が無効です。",
	"Invalid label value.": "ラベル値が無効です。",
	"Items per page:": "ページあたりの項目数:",
	January: January,
	July: July,
	June: June,
	Key: Key,
	"Key aliases": "主な別名",
	"Key CRN": "鍵 CRN",
	"Key description": "キーの説明",
	"Key description must be at least 2 characters and no more than 240 characters.": "キーの説明は 2 文字以上 240 文字以下である必要があります。",
	"Key ID": "鍵 ID",
	"Key management": "鍵管理",
	"Key management service": "キー管理サービス",
	"Key material": "キー素材",
	"Key material is required to import a key": "鍵のインポートには鍵素材が必要",
	"Key material length must be 128, 192, or 256 bits": "キーマテリアルの長さは 128、192、または 256 ビットでなければならない",
	"Key material must be base64": "キー素材は base64 でなければならない",
	"Key name": "キーの名前",
	"Key Protect": "Key Protect",
	"Key Protect instance name": "Key Protect インスタンス名",
	"Key ring": "鍵リング",
	"Key value": "キー値",
	"Label must be of the form 'key:value'.": "ラベルの形式は 'key:value' でなければなりません。",
	"Label name must be no more than {{maxLength}} characters.": "ラベル名は {{maxLength}} 文字以内でなければなりません。",
	"Label prefix must be a valid DNS subdomain.": "ラベル接頭部には、有効な DNS サブドメインを指定してください。",
	"Label prefix must be no more than {{maxLength}} characters.": "ラベル接頭部は {{maxLength}} 文字以内でなければなりません。",
	"Label value must be no more than {{maxLength}} characters.": "ラベル値は {{maxLength}} 文字以内でなければなりません。",
	"Large (48px)": "大(48px)",
	"Last modified": "最終変更日時",
	"Last scanned": "最終のスキャン日時",
	"Last updated": "最終更新",
	Launch: Launch,
	"Launch activiting tracking": "アクティブ化トラッキングの起動",
	"Launch in new window": "新規ウィンドウで起動",
	"Launch logging": "ロギングの起動",
	"Launch monitoring": "モニタリングの起動",
	"Learn more": "詳細情報",
	"learn more.": "詳細情報。",
	"Learn more.": "詳細情報。",
	"List of actions": "アクションのリスト",
	"list of code sample types": "コード・サンプル・タイプのリスト",
	Lite: Lite,
	Loading: Loading,
	"Loading indicator": "ローディング・インディケーター",
	"Loading...": "ロード中...",
	"Locate by CRN within your account": "アカウント内の CRN で検索",
	Location: Location,
	"Location summary": "ロケーション・サマリー",
	"Location:": "ロケーション:",
	Locations: Locations,
	"Log collection is already enabled for this resource": "このリソースでは、ログ収集はすでに有効になっています",
	"Log collection is enabled for this resource and sent to targets as defined by your routing configuration.": "このリソースではログ収集が有効になり、ルーティング設定で定義されたターゲットに送信されます。",
	Logging: Logging,
	"Logging (error)": "ロギング（エラー）",
	"Logging is recommended for optimal troubleshooting and reducing downtime": "最適なトラブル・シューティングとダウンタイムの削減のために、ログの取得を推奨します",
	"Logging...": "ログ...",
	London: London,
	"Looking for valid service to service authorization policy...": "有効なサービス間承認ポリシーを探しています...",
	"Looks like you are missing the required permissions to create the policy. Contact your account administrator": "ポリシーを作成するために必要な権限が不足しているようです。 アカウント管理者に連絡する",
	"Looks like you don't have access to view account information.": "アカウント情報を表示するためのアクセス権限がないようです。",
	"Looks like you don't have access to view the billing period": "請求対象期間を表示するためのアクセス権限がないようです",
	"Looks like you don't have any scans": "スキャンがないようです",
	"Looks like you don't have the access needed to view this information. Contact your account administrator to verify your permissions.": "この情報を表示するために必要なアクセス権限がないようです。 アカウント管理者に連絡して、権限を確認してください。",
	"Looks like you don't have the correct access": "正しいアクセス権限を持っていないようです",
	"Looks like you don't have the correct access. You must have access to the target service to create an authorization between services.": "適切なアクセス権限がありません。 サービス間の許可を作成するには、ターゲット・サービスにアクセスできる必要があります。",
	"Make sure you have Topics, Subscriptions and Destinations setup in Event Notifications.": "Event Notifications でトピック、サブスクリプション、および宛先がセットアップされていることを確認します。",
	"Manage encryption by enabling a key management service (KMS).": "鍵管理サービス（KMS）を有効にして暗号化を管理する。",
	"Manage routing": "ルーティングの管理",
	"Manage the lifecycle of your encryption keys that are used for you IBM Cloud resources, services, and applications.": "IBM Cloud リソース、サービス、およびアプリケーションに使用されている暗号鍵のライフサイクルを管理します。",
	"Managed from": "管理元",
	March: March,
	May: May,
	"Media gallery video": "メディア・ギャラリー・ビデオ",
	"Medium (40px)": "中(40px)",
	"Metadata location": "メタデータの場所",
	Metro: Metro,
	"Minimum host requirements are met.": "最小ホスト要件が満たされています。",
	Minute: Minute,
	"Minute (UTC)": "分(UTC)",
	"Missing prerequisite services": "前提条件サービスがありません",
	mo: mo,
	"Modify the arguments passed into your datahook here.": "ここでdatahookに渡される引数を変更します。",
	"Mon-Fri": "月曜日から金曜日",
	Monday: Monday,
	"Monitor all of your environments for compliance by setting up scans.": "スキャンをセットアップして、すべての環境のコンプライアンスをモニターします。",
	"Monitor and audit IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "セキュリティとコンプライアンスを強化するために、IBM Cloud アクティビティを監視および監査します。 <a>詳細はこちら</a>",
	Monitoring: Monitoring,
	Month: Month,
	"Month (UTC)": "月(UTC)",
	more: more,
	Name: Name,
	"Name already in use. Provide a unique name.": "名前は既に使用中です。 固有の名前を付けます。",
	"Name must be between 2 and 90 characters": "氏名は 2 文字以上 90 文字以内",
	"Name this project": "このプロジェクトに名前を付けます",
	Namespace: Namespace,
	Namespaces: Namespaces,
	"New instance": "新規インスタンス",
	Next: Next,
	"Next page": "次ページ",
	"Next: Customize": "次へ: カスタマイズ",
	"nmpc-1, namespc-2": "nmpc-1, namespc-2",
	No: No,
	"No available catalog regions": "使用可能なカタログ・リージョンがありません",
	"No Cloud Object Storage instance is available.": "クラウド・オブジェクト・ストレージ・インスタンスは使用できません。",
	"No code preview has been configured for terraform. Please visit our docs to ": "Terraformのコード・プレビューが構成されていません。 こちらの資料を参照してください: ",
	"No configurations available": "使用可能な構成がありません",
	"No events can be scheduled with your selected CRON expression.": "選択したCRON式ではイベントをスケジュールできません。",
	"No Hyper Protect Crypto Services instances found": "Hyper Protect Crypto Services インスタンスが見つかりません",
	"No instances found": "インスタンスが見つかりません",
	"No item matches the filters. Clear the filters and try again.": "フィルターに一致する項目がありません。 フィルターをクリアしてから、再試行してください。",
	"No items available to display. Select an instance and bucket to view objects.": "表示できる項目がありません。 オブジェクトを表示するインスタンスとバケットを選択します。",
	"No items match the current filter.": "現在のフィルターに一致する項目はありません。",
	"No keys available": "使用可能な鍵がありません",
	"No matches found. To create new tags, contact your tag administrator.": "一致するものが見つかりませんでした。 新しいタグを作成するには、タグ管理者に連絡してください。",
	"No matching options": "一致するオプションはありません",
	"No matching region ID's are available on this account. If you think this is an error, refresh the page or contact your administrator.": "このアカウントには一致するリージョンIDがありません。 これがエラーであると思われる場合は、ページを最新表示するか、管理者にお問い合わせください。",
	"No plans found": "プランが見つかりませんでした",
	"No regions available": "使用可能なリージョンはありません。",
	"No resource groups available": "使用可能なリソース・グループがありません",
	"No secret available": "使用可能なシークレットなし",
	"No secret group available": "使用可能なシークレット・グループなし",
	"No service instance available": "使用可能なサービス・インスタンスなし",
	"No valid version update options are available.": "有効なバージョン更新オプションがありません。",
	"Non-compliant": "非準拠",
	None: None,
	"None available": "使用できるものがありません",
	Normal: Normal,
	"Normal (48px)": "標準 (48px)",
	"Not authorized": "許可されていません",
	"Not ready": "作動不可",
	Note: Note,
	Notification: Notification,
	November: November,
	"Object": "オブジェクト",
	"Object storage": "オブジェクト・ストレージ",
	"Object storage is used to store data about your location and backups for your location's clusters. <a>Learn more.</a>": "オブジェクト・ストレージは、ロケーションに関するデータとロケーションのクラスターのバックアップを保管するために使用されます。 <a>詳細はこちらをご覧ください。</a>",
	Objects: Objects,
	October: October,
	Off: Off,
	OK: OK,
	On: On,
	"Once a day": "1日に1回",
	"Once a month": "1カ月に1回",
	"Once a week": "1週間に1回",
	"Once a year": "1年に1回",
	Open: Open,
	"Open dashboard": "ダッシュボードを開く",
	"Open Dashboard": "ダッシュボードを開く",
	"Open menu": "メニューを開く",
	"Open page navigation menu": "ページ・ナビゲーション・メニューを開く",
	"Open reference picker": "リファレンスピッカーを開く",
	"Open tab list": "タブ・リストを開く",
	Osaka: Osaka,
	"Overflow menu": "オーバーフロー・メニュー",
	"Overflow Menu": "オーバーフロー・メニュー",
	Overview: Overview,
	Packages: Packages,
	"page {{pageNumber}}": "ページ {{pageNumber}}",
	"Page Navigation": "ページ・ナビゲーション",
	"Page navigation menu": "ページ・ナビゲーション・メニュー",
	"Page number": "ページ番号",
	Pattern: Pattern,
	"Pay-As-You-Go": "従量制課金",
	Pending: Pending,
	Plan: Plan,
	"Platform access": "プラットフォーム・アクセス",
	"Platform logs from {{region}} will be sent to a new instance": "{{region}} からのプラットフォームのログは、新しいインスタンスに送られます",
	"Platform logs from {{region}} will be sent to an existing instance": "{{region}} からのプラットフォームログは、既存のインスタンスに送信されます",
	"Platform logs from {{region}} will be sent to the target instance. <a>Learn more</a>": "{{region}} からのプラットフォーム・ログはターゲット・インスタンスに送られる。 <a>詳細はこちら</a>",
	"Platform logs will be collected from enabled IBM Cloud services according to the defined routing scope.": "プラットフォームのログは、定義されたルーティング スコープに従って、有効な IBM Cloud サービスから収集されます。",
	"Please <a>sign up</a> to create or <a>login</a> before applying the promo code.": "割引コードを適用するには、まず<a>登録</a>して作成するか、<a>ログイン</a>してください。",
	"Prefix filter": "接頭部フィルター",
	Premium: Premium,
	"Preparing master, workers...": "マスター、ワーカーの準備中...",
	"Preparing master...": "マスターの準備中...",
	"Prerequisite services installed": "インストールされている前提条件サービス",
	Previous: Previous,
	"Previous page": "前のページ",
	"Pricing Plans": "料金プラン",
	"prj-1, projct-2": "prj-1, projct-2",
	Product: Product,
	Products: Products,
	Project: Project,
	Projects: Projects,
	Property: Property,
	"Provide a more detailed description of the key. To protect your privacy, do not use personal data, such as your name or location, as a description. You cannot change this after key creation.": "キーの詳細な説明を指定します。 プライバシーを保護するために、名前や場所などの個人データを説明として使用しないでください。 鍵の作成後にこれを変更することはできません。",
	provided: provided,
	Provider: Provider,
	"Provides visibility of the performance and health of your IBM Cloud powered resources application.": "IBM Cloud を採用したリソース・アプリケーションのパフォーマンスと正常性の可視性を提供します。",
	Provisioning: Provisioning,
	Ready: Ready,
	"Ready to apply?": "適用の準備はできましたか?",
	Refresh: Refresh,
	"Refresh Cloud Object Storage instances": "クラウド・オブジェクト・ストレージ・インスタンスの最新表示",
	"Refresh data": "データの更新",
	"Refresh secrets": "シークレットの最新表示",
	region: region,
	Region: Region,
	Remove: Remove,
	"Remove sort": "ソートを解除",
	"Rendering modify hooks is not supported to prevent unexpected resource changes.": "予期しないリソース変更を防ぐため、フック変更のレンダリングはサポートされていません。",
	Renew: Renew,
	Repositories: Repositories,
	Requested: Requested,
	"Requesting creation...": "作成の要求中...",
	Required: Required,
	Reservations: Reservations,
	Reset: Reset,
	"Reset filters": "フィルターのリセット",
	"Reset to default": "デフォルトにリセット",
	"Reset zoom": "ズームのリセット",
	"Resource Configuration": "リソース構成",
	"Resource group": "リソース・グループ",
	"Resource group:": "リソース・グループ:",
	"Resource list": "リソース・コスト",
	"Resource List": "リソース・リスト",
	resources: resources,
	Resources: Resources,
	"Resources not included in cost": "コストに含まれないリソース",
	"Restricted access": "制限付きアクセス",
	Results: Results,
	"Retrying delete": "削除再試行中",
	"Retrying deploy": "デプロイ再試行中",
	"Revert {{resetCount}} to default": "{{resetCount}} をデフォルトに戻す",
	Review: Review,
	"Review access assignments to {{resourceDisplayName}}": "{{resourceDisplayName}} に対するアクセス権限の割り当ての確認",
	"Review settings in Event Notifications": "Event Notifications での設定の確認",
	"Review the following access group policies to ensure you're assigning the right level of access.": "以下のアクセス・グループ・ポリシーを参照し、適切なレベルのアクセス権限を割り当てていることを確認してください。",
	"Rotation interval": "ローテーション間隔",
	"Rotation policies determine the interval between automatic key rotations. An interval of one month, for example, means that a key will be rotated every 30 days. If the policy is already enabled, this means that an instance policy exists for this instance and if no other action is taken, the rotation interval shown will be applied to the key. If it is disabled, enable it to set a policy for this key.": "ローテーション・ポリシーは、鍵の自動ローテーションの間隔を決定します。 例えば、1 カ月の間隔は、鍵が 30 日ごとにローテーションされることを意味します。 ポリシーが既に有効になっている場合は、このインスタンスのインスタンス・ポリシーが存在することを意味し、他のアクションが実行されない場合は、表示されているローテーション間隔が鍵に適用されます。 無効になっている場合は、この鍵のポリシーを設定できるようにします。",
	"Rotation policy": "ローテーション・ポリシー",
	"Rotation policy disabled": "ローテーション・ポリシー無効",
	"Route name": "ルート名",
	Routing: Routing,
	"Routing scope": "ルーティング範囲",
	"Row height": "行の高さ",
	"Sample not yet available": "サンプルはまだ使用できません",
	"Sao Paulo": "サンパウロ",
	"Sat-Sun": "土曜日と日曜日",
	Satellite: Satellite,
	"Satellite container": "Satellite コンテナー",
	"Satellite location": "Satellite ロケーション",
	"Satellite location base cost": "Satellite ロケーションの基本コスト",
	"Satellite location base functionality": "Satellite ロケーション・ベースの機能",
	Saturday: Saturday,
	Save: Save,
	"Saving...": "保存中...",
	Scanning: Scanning,
	Schedule: Schedule,
	"Schematics workspaces and other project data are stored in the selected region and resource group. <a>Learn more.</a>": "Schematics ワークスペースおよびその他のプロジェクト・データは、選択した領域およびリソース・グループに保管されます。 <a>詳細はこちらをご覧ください。</a>",
	"Schematics workspaces are provisioned in this region. Your project can still deploy resources to any region.": "Schematics ワークスペースは、このリージョンにプロビジョンされます。 プロジェクトは、引き続き任意のリージョンにリソースをデプロイできます。",
	"Schematics workspaces are provisioned in this resource group. Your project can still deploy resources to any resource group.": "Schematics ワークスペースは、このリソース・グループにプロビジョンされます。 プロジェクトは、引き続き任意のリソース・グループにリソースをデプロイできます。",
	Search: Search,
	"Search in this instance": "この場合の検索",
	Secret: Secret,
	"Secret configured": "シークレットが構成されました",
	"Secret group": "シークレット・グループ",
	"Secret type": "シークレットのタイプ",
	"Secrets Manager": "Secrets Manager",
	"Secure value": "セキュアな値",
	"See details": "詳細を表示",
	Select: Select,
	"Select a location to see what steps you need to take next.": "ロケーションを選択して、次に実行するステップを確認します。",
	"Select a project": "プロジェクトの選択",
	"Select a reference": "参照の選択",
	"Select a region": "リージョンを選択します",
	"Select a resource group": "リソース・グループの選択",
	"Select a role to determine the level of access for the source service.": "ソース・サービスのアクセス権限のレベルを決定するために役割を選択してください。",
	"Select a secret": "シークレットの選択",
	"Select a secret group": "シークレット・グループの選択",
	"Select a service instance": "サービス・インスタンスの選択",
	"Select all {{totalRowCount}} items": "すべての {{totalRowCount}} 項目を選択",
	"Select all rows on page": "ページ上の行をすべて選択",
	"Select an environment": "環境の選択",
	"Select an existing configuration": "既存の構成を選択",
	"Select an IBM Cloud Monitoring instance to receive platform metrics": "プラットフォーム・メトリックを受け取る IBM Cloud Monitoring インスタンスの選択",
	"Select an IBM Log Analysis instance to receive platform logs": "プラットフォーム・ログを受け取る IBM Log Analysis インスタンスの選択",
	"Select an instance": "インスタンスの選択",
	"Select an instance to show keys": "鍵を表示するインスタンスの選択",
	"Select an option...": "オプションの選択...",
	"Select existing key": "既存のキーを選択",
	"Select from Secrets Manager": "Secrets Manager から選択してください",
	"Select KMS instance": "KMS インスタンスを選択",
	"Select namespaces": "名前空間の選択",
	"Select one or more namespaces": "1 つ以上の名前空間の選択",
	"Select one or more projects": "1 つ以上のプロジェクトの選択",
	"Select prerequisites": "前提条件を選択する",
	"Select projects": "プロジェクトの選択",
	"Select region and resource group": "地域およびリソース・グループの選択",
	"Select row": "行を選択",
	"Select the <a>IBM Cloud region</a> that is closest to where your infrastructure resides to ensure low network latency.": "ネットワーク待ち時間を短くするために、インフラストラクチャーが存在する場所に最も近い<a>IBM Cloudリージョン</a>を選択します。",
	"Select the following tile to deploy it.": "以下のタイルを選択して配置する。",
	"Send all audit events from enabled resources in {{region}}.": "{{region}} で有効になっているリソースからのすべての監査イベントを送信します。",
	"Send all available audit events in this account.": "このアカウントで利用可能なすべての監査イベントを送信します。",
	"Send events to": "イベントの送信先",
	"Send logs to": "ログの送信先",
	"Send test notification": "テスト通知を送信する",
	Sending: Sending,
	"Sent!": "送信されました。",
	September: September,
	Serverless: Serverless,
	"Serverless projects": "サーバーレス・プロジェクト",
	Service: Service,
	"Service access": "サービス・アクセス",
	"Service authorization": "サービス許可",
	"Service authorization is required to allow Activity Tracker Event Routing to communicate with Cloud Logs. Click <span>Authorize now</span> to create a policy scoped to all Cloud Logs resources in this account.": "Activity Tracker Event Routing が Cloud Logs と通信できるようにするには、サービスの承認が必要です。 <span>Authorize now</span> をクリックして、このアカウントのすべての Cloud Logs リソースをスコープとするポリシーを作成します。",
	"Service authorization required": "サービス許可が必要です",
	"Service instance": "サービス・インスタンス",
	"Service name": "サービス名",
	"Service to service authorization must be provided for your instance. <a>Learn more</a>": "サービス間許可をインスタンスに提供する必要があります。 <a>詳細はこちら</a>",
	"Service to service authorization policy found": "サービス間の認可ポリシーが見つかりました",
	"Service to service authorization policy needed": "サービス間の認可ポリシーが必要",
	"Service type": "サービス・タイプ",
	"Service-to-service authorization couldn't be verified. Manually add and check the required roles.": "サービス間の許可を検証できませんでした。 必要な役割を手動で追加して確認してください。",
	"Service-to-service authorization requirements are met.": "サービス間の許可の要件が満たされています。",
	"Set an interval (in months)": "間隔の設定 (月数)",
	"Set key rotation policy": "鍵ローテーション・ポリシーの設定",
	"Set up auth": "認証のセットアップ",
	Settings: Settings,
	"Short (32px)": "低 (32px)",
	"Show all filters": "すべてのフィルターの表示",
	"Show code sample": "コード・サンプルの表示",
	"Show environments information": "環境情報を表示する",
	"Show error information": "エラー情報を表示する",
	"Show information": "情報の表示",
	"Show less": "表示を減らす",
	"Show more": "さらに表示",
	"Show more details": "詳細を表示",
	"Show password": "パスワードを表示する",
	"Show tooltip": "ツールチップを表示します。",
	"Showing {{count}} item": "{{count}} 個の項目を表示中",
	"Showing {{count}} items": "{{count}} 個の項目を表示中",
	Size: Size,
	"Small (32px)": "小(32px)",
	"Some events from {{serviceName}}:": "{{serviceName}}からのいくつかのイベント：",
	"Something went wrong": "何らかの問題が発生しました",
	"Something went wrong.": "何らかの問題が発生しました。",
	"Something went wrong. Try reloading the page to see this information": "何らかの問題が発生しました。 この情報を表示するため、ページを再ロードしてみてください",
	Sort: Sort,
	"Sort ascending": "昇順にソート",
	"Sort descending": "降順にソート",
	Source: Source,
	"Source Details": "ソースの詳細",
	"Source for the service does not exist in Event Notifications instance. Contact your administrator.": "サービスのソースがEvent Notificationsインスタンスに存在しません。 管理者に問い合わせてください。",
	"Source service": "ソース・サービス",
	"Specific namespaces not supported": "特定の名前空間がサポートされない",
	"Specific projects not supported": "特定のプロジェクトがサポートされない",
	Start: Start,
	"Start by creating a cluster that is just right to run your workloads.": "まず始めに、ご使用のワークロードを実行するのに適したクラスターを作成します。",
	"Start date": "開始日",
	"Starting at": "開始時刻",
	"Starting costs are based on this resource configuration. You can edit configurations after you add this product to a project, which might impact costs.": "スターティング・コストはこのリソース構成に基づいている。 この製品をプロジェクトに追加した後でも、設定を編集することができます。",
	State: State,
	Status: Status,
	"status icon": "状況アイコン",
	"Stay in pattern": "パターンを維持する",
	"Steps complete": "ステップが完了",
	Storage: Storage,
	"Storage bucket (optional)": "ストレージ・バケット (オプション)",
	"Storage configuration missing": "ストレージ構成がありません",
	"Storage ready": "ストレージは作動可能です",
	"Store, search, analyze, monitor, and alert on your IBM Cloud logging data and events.": "IBM Cloud ロギング・データとイベントを保管、検索、分析、モニターし、これらについて警報を出します。",
	Submit: Submit,
	Subscription: Subscription,
	Success: Success,
	"success state": "正常終了状態",
	"Success! This promotion was applied to your account.": "成功! このプロモーションはご使用のアカウントに適用されました。",
	"Successfully created new Key Protect instance": "新しい Key Protect インスタンスの作成に成功しました",
	Summary: Summary,
	Sunday: Sunday,
	"Support Plan": "サポート・プラン",
	"Switch to folders view": "フォルダー・ビューに切り替える",
	"Switch to objects view": "オブジェクト・ビューに切り替える",
	Sydney: Sydney,
	"Syntax: ": "構文: ",
	tag: tag,
	"Tag '{{tagName}}' could not be created as the name is invalid.": "名前が無効であるため、タグ '{{tagName}}' を作成できませんでした。",
	tags: tags,
	Tags: Tags,
	"Tags:": "タグ:",
	"Tags: (optional)": "タグ: (オプション)",
	"Tall (64px)": "高 (64px)",
	"Target destination": "ターゲット宛先",
	"Target location": "ターゲット・ロケーション",
	"Target name": "ターゲット名",
	"Target selected": "選択されたターゲット",
	"Target service instance": "ターゲット・サービス・インスタンス",
	"Target type": "ターゲット・タイプ",
	"Template error": "テンプレート・エラー",
	"Terms and conditions": "使用条件",
	"Test notification": "テスト通知",
	"The address field is required.": "アドレス・フィールドは必須です。",
	"The catalog window might have been blocked from opening.": "カタログ・ウィンドウのオープンがブロックされている可能性があります。",
	"The connected Event Notifications instance was deleted from the account. To continue using notifications, disconnect the current instance by clicking Disconnect from the menu ( ⋮ ). Then, connect another Event Notifications instance.": "接続された Event Notifications インスタンスがアカウントから削除されました。 通知を引き続き使用するには、メニュー ( ⋮ )から「切断」をクリックして、現在のインスタンスを切断します。 次に、別の Event Notifications インスタンスを接続します。",
	"The description should not contain any leading or trailing whitespace characters.": "説明の先頭または末尾に空白文字を含めることはできません。",
	"The description should not exceed {{limit}} characters in length.": "説明文は {{limit}} 文字を超えてはいけません。",
	"The following access is required:": "以下のアクセス権限が必要です。",
	"The following code preview displays the corresponding request as CLI commands. Use it as a starting point for writing your own automation. ": "以下のコード・プレビューでは、対応する要求がCLIコマンドとして表示されます。 これを独自の自動化を作成するための開始点として使用してください。 ",
	"The following code preview displays the corresponding request as REST API calls. Use it as a starting point for writing your own automation. ": "以下のコード・プレビューでは、対応する要求がREST API呼び出しとして表示されます。 これを独自の自動化を作成するための開始点として使用してください。 ",
	"The following code preview displays the corresponding request with Terraform. Use it as a starting point for writing your own automation. ": "以下のコード・プレビューでは、Terraformに対応する要求が表示されます。 これを独自の自動化を作成するための開始点として使用してください。 ",
	"The following preview displays the corresponding request as code. Use it as a starting point for writing your own automation.": "以下のプレビューでは、対応する要求がコードとして表示されます。 これを独自の自動化を作成するための開始点として使用してください。",
	"The following resources were not included in the cost estimate but might have an associated cost.": "以下のリソースはコスト見積もりに含まれませんでしたが、コストが関連付けられている可能性があります。",
	"The IAM role manager for {{serviceName}}": "{{serviceName}} の IAM ロールマネージャ",
	"The instance can't be accessed because a service to service authorization was removed from the account. Create an authorization with Event Source Manager access between {{sourceServiceName}} and Event Notifications.": "サービス間の許可がアカウントから削除されたため、インスタンスにアクセスできません。 {{sourceServiceName}} と Event Notifications の間で、イベント・ソース・マネージャのアクセス権限を作成します。",
	"The list of namespaces can't be populated. Try again later.": "名前空間のリストを設定できません。 後でもう一度試してください。",
	"The list of projects can't be populated. Try again later.": "プロジェクトのリストを設定できません。 後でもう一度試してください。",
	"The name is required.": "名前は必須です。",
	"The name must be {{max}} or fewer characters, begin with a letter, and contain only alphanumeric characters, '-', and '.'": "名前は {{max}} 文字以下で、文字で始まり、英数字、「-」、および「.」のみを含めてください",
	"The name of a namespace can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "名前空間名に使用できるのは、小文字、数字、およびダッシュのみです。 名前の先頭と末尾にはダッシュを使用できず、最大 63 文字でなければなりません。",
	"The name of a project can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "プロジェクト名に使用できるのは、小文字、数字、およびダッシュのみです。 名前の先頭と末尾にはダッシュを使用できず、最大 63 文字でなければなりません。",
	"The name should contain only alphanumeric, underscore, dashes and space.": "名前には、英数字、下線、ダッシュ、およびスペースのみを含める必要があります。",
	"The name should not contain any special characters.": "名前に特殊文字を指定できません。",
	"The name should not exceed {{limit}} characters in length.": "名前の長さは {{limit}} 文字を超えてはいけません。",
	"The region is required.": "地域は必須です。",
	"The resource group is required.": "リソース・グループは必須です。",
	"The resource group window might have been blocked from opening.": "リソース・グループ・ウィンドウを開けないようになっている可能性があります。",
	"The tag name must be in a key:value format": "タグ名は「キー:値」の形式でなければなりません",
	"The tag name must be in a key:value format.": "タグ名はkey: value形式でなければなりません。",
	"The window might have been blocked from opening.": "ウィンドウのオープンがブロックされている可能性があります。",
	"There was a problem loading resource groups.": "リソース・グループのロード中に問題が発生しました。",
	"These roles allow access for using the service and performing service API calls. Each role is customized by the selected service. Select all that apply. Refer to the service's documentation for more details.": "これらの役割は、サービスの使用およびサービス API 呼び出しの実行のためのアクセスを許可します。 各役割は、選択されたサービスによってカスタマイズされます。 該当するものをすべて選択してください。 詳しくは、サービスの資料を参照してください。",
	"These roles are created by administrators in the account to customize how access is assigned to the service. Click the Actions for role icon to review what actions are mapped to this role.": "これらの役割は、サービスへのアクセス権限の割り当てをカスタマイズするために、アカウント内の管理者によって作成されます。 「役割のアクション」アイコンをクリックすると、この役割にマップされているアクションを確認できます。",
	"These roles enable actions to be performed on platform resources, such as creating an instance, connecting instances to apps, and assigning user access. Select all that apply.": "これらの役割は、プラットフォーム・リソースに対して、インスタンスの作成、アプリへのインスタンスの接続、ユーザー・アクセス権限の割り当てなどのアクションを実行できるようにします。 該当するものをすべて選択してください。",
	"This field is required": "このフィールドは必須です",
	"This is currently not being sent on submit and is pending an update from the team responsible for the API.": "これは現在のところ送信時に送信されておらず、APIを担当するチームからの更新を保留しています。",
	"This is how your {{serviceName}} instance is referenced in Event Notifications": "このように、{{serviceName}} インスタンスは、Event Notifications で参照されます",
	"This project name \"{{name}}\" already exists, please choose another name.": "このプロジェクト名「{{name}}」は既に存在します。",
	"This section is under construction, come back later.": "このセクションは準備中です。後ほどご確認ください。",
	"This service requires additional storage assigned to the cluster. No matching storage configuration exists.": "このサービスには、クラスターに割り当てられた追加ストレージが必要です。 一致するストレージ構成が存在しません。",
	"This tag already exists. Choose another name for your tag.": "このタグは既に存在しています。 タグに別の名前を選択してください。",
	"This value already exists.": "この値は既に存在しています。",
	"This view is not available for some account types": "このビューは、一部のアカウント・タイプでは使用できません",
	"Three zone names are required": "3 つのゾーン名が必要です",
	Thursday: Thursday,
	"To add HPCS encryption, follow these steps:": "HPCS 暗号化を追加するには、以下の手順に従ってください：",
	"To connect, the instance in this region must be configured for platform": "接続するためには、プラットフォーム用にこのリージョンのインスタンスが構成されている必要があります",
	"To control the notifications of the events generated by {{serviceName}}, connect to an Event Notifications instance. <a>Learn more</a>": "{{serviceName}} が生成したイベントの通知をコントロールするには、Event Notifications インスタンスに接続します。 <a>詳細はこちら</a>",
	"To create a new HPCS key, follow the steps below...": "新しい HPCS キーを作成するには、以下の手順に従ってください。",
	Tokyo: Tokyo,
	Topics: Topics,
	Toronto: Toronto,
	Total: Total,
	"Total accounts": "アカウントの合計",
	"Total estimated cost": "見積コストの合計",
	"Transaction ID": "トランザクション ID",
	Trash: Trash,
	Trial: Trial,
	"Try again later, or contact your account administrator.": "後で再試行するか、アカウント管理者に連絡してください。",
	"Try again later.": "後でもう一度試してください。",
	"Try refreshing the page and then performing the action again to see if the problem persists. If so, make sure you're using a <a>supported browser</a> and check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "ページを最新表示してからもう一度アクションを実行して、問題が解決するか確認してください。 問題が解決しない場合は、<a>対応ブラウザー</a>を使用していることを確認し、<a>状況ページ</a>を確認して、問題が発生していないか確認してください。 それでも問題が解決しない場合には、<a>サポート</a>にお問い合わせください。",
	"Try waiting a few minutes and perform the action again to see if the problem persists. If so, check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "数分待ってからアクションを再度実行し、問題が解決したかどうかを確認します。 解決していない場合は、<a>ステータス・ページ</a>を確認して、他の問題が発生しているかどうか確認してください。 それでも問題が解決しない場合には、<a>サポート</a>にお問い合わせください。",
	Tuesday: Tuesday,
	"Type \"{{clusterName}}\" to confirm": "「{{clusterName}}」と入力して確認する",
	"Type \"{{name}}\" to confirm": "確認のために「{{name}}」を入力してください",
	"Unable to configure activity tracker event routing.": "アクティビティ・トラッカーのイベント・ルーティングを設定できません。",
	"Unable to configure Activity Tracker integration.": "Activity Tracker の統合を設定できません。",
	"Unable to configure Logging integration.": "ログの統合を設定できません。",
	"Unable to configure logging.": "ロギングを設定できません。",
	"Unable to connect your service to Event Notifications service. Try again later.": "サービスをEvent Notificationsサービスに接続できません。 後でもう一度試してください。",
	"Unable to create authorization policy.": "許可ポリシーを作成できません。",
	"Unable to create Satellite location": "Satelliteロケーションを作成できません",
	"Unable to create the service to service policy at this time. Refresh the page, or try again later.": "現時点ではサービス間ポリシーを作成できません。 ページを最新表示するか、後で再試行してください。",
	"Unable to delete cluster": "クラスタを削除できない",
	"Unable to disconnect Event Notifications instance. Refresh the page, or try again later.": "Event Notificationsインスタンスを切断できません。 ページを最新表示するか、後で再試行してください。",
	"Unable to get cluster data": "クラスター・データを取得できません",
	"Unable to get Event Notifications instance details. Refresh the page, or try again later.": "Event Notificationsインスタンスの詳細を取得できません。 ページを最新表示するか、後で再試行してください。",
	"Unable to get storage instances.": "ストレージ・インスタンスを取得できません。",
	"Unable to list clusters.": "クラスターをリストできません。",
	"Unable to list locations.": "ロケーションをリストできません。",
	"Unable to load Activity Tracker service catalog data": "Activity Tracker サービス・カタログ・ データをロードできません",
	"Unable to load Cloud Logs service catalog data": "Cloud Logs サービス・カタログ・データをロードできない",
	"Unable to load cluster details.": "クラスターの詳細をロードできません。",
	"Unable to load cluster update version options.": "クラスター更新バージョン・オプションをロードできません。",
	"Unable to load event routing settings": "イベント・ルーティング設定をロードできない",
	"Unable to load event routing target instances": "イベント・ルーティングのターゲット・インスタンスをロードできない",
	"Unable to load event routing target instances.": "イベント・ルーティングのターゲット・インスタンスをロードできません。",
	"Unable to load event routing targets": "イベント・ルーティング・ターゲットをロードできない",
	"Unable to load event routing targets.": "イベント・ルーティング・ターゲットをロードできません。",
	"Unable to load IBM Cloud locations data": "IBM Cloud のロケーション ・データをロードできません",
	"Unable to load logging instances": "ロギング・インスタンスをロードできない",
	"Unable to load logging instances.": "ロギング・インスタンスをロードできません。",
	"Unable to load logging service catalog data": "ロギング・サービスのカタログデータをロードできない",
	"Unable to load logs routing targets": "ルーティング・ターゲットのログをロードできない",
	"Unable to load logs routing targets.": "ルーティング・ターゲットのログをロードできません。",
	"Unable to perform": "実行不可",
	"Unable to retrieve cluster details": "クラスタの詳細を取得できない",
	"Unable to retrieve data": "データを取得できません",
	"Unable to retrieve location information.": "ロケーション情報を取得できません。",
	"Unable to retrieve project configurations.": "プロジェクトの設定を取得できません。",
	"Unable to send test notification to Event Notifications instance. Try again later.": "Event Notificationsインスタンスにテスト通知を送信できません。 後でもう一度試してください。",
	"Unable to send the test notification to Event Notifications instance. Check if Topics are setup in Event Notifications.": "Event Notificationsインスタンスにテスト通知を送信できません。 Event Notificationsでトピックがセットアップされているかどうかを確認します。",
	"Unable to update cluster version.": "クラスター・バージョンを更新できません。",
	Unknown: Unknown,
	"unknown state": "不明な状態",
	"Unselect all rows": "すべての行を選択解除",
	"Unselect row": "行の選択解除",
	Unsupported: Unsupported,
	"Unsupported version. Update the version to continue to receive support.": "サポートされないバージョンです。 サポートを続行するには、このバージョンを更新してください。",
	"Upcoming scheduled events in your timezone": "タイムゾーンで予定されているイベント",
	Update: Update,
	"Update available": "更新が利用可能",
	"Update cluster version": "クラスターのバージョンの更新",
	"Update tags": "タグを更新する",
	"Update version": "更新バージョン",
	"Updating...": "更新中...",
	Upgrade: Upgrade,
	"Upgrade your account to view the billing period.": "請求対象期間を表示するには、アカウントをアップグレードしてください。",
	"Usage based charges apply per gigabyte of audit events ingested.": "使用量に基づく料金は、取り込まれた監査イベントのギガバイトごとに適用されます。",
	"Usage based charges apply per gigabyte of logs ingested.": "使用量に基づく料金は、取り込まれたログのギガバイトごとに適用されます。",
	"Usage costs": "利用コスト",
	"Use a secret to securely and centrally manage your credentials for authentication. <a>Learn more</a>": "シークレットを使用して、認証用の資格情報を安全かつ一元的に管理します。 <a>詳細はこちら</a>",
	"Use a secret?": "シークレットを使用しますか?",
	"Use existing": "既存のものを使用",
	"Use key aliases to easily identify your keys. A key alias is a unique and easily recognizable custom name.": "鍵のエイリアスを使用して、簡単に鍵を識別します 鍵のエイリアスは固有であり、分かりやすいカスタム名です。",
	"Use tags to organize your resources. If your user tags are billing related, consider writing tags as key:value pairs to help group related tags, such as": "タグを使用してリソースを編成できます。 ユーザー・タグが請求に関連している場合は、関連したタグのグループ化に役立つよう、以下のように「キー:値」のペアとしてタグを記述することを検討してください。",
	"Use the options below to choose the item that the reference will be created for.": "以下のオプションを使用して、参照を作成する項目を選択します。",
	"User evaluation required": "ユーザー評価が必要",
	"User permissions failure": "ユーザー権限の失敗",
	"User tags": "ユーザー・タグ",
	"User tags (optional": "ユーザー・タグ(オプション)",
	"User tags are visible account-wide. Avoid including sensitive data in the tag name.": "ユーザー・タグはアカウント全体で表示されます。 タグ名に機密データを含めないでください。",
	Value: Value,
	"Value must be a valid array (Ex. [\"array\"]). To specify a null array use \"__NOT_SET__\"": "値は有効な配列でなければなりません (例えば、[\"array\"])。 NULL配列を指定するには「__NOT_SET__」を使用します",
	Values: Values,
	"Verify that the following services have been installed on the location: {{missingServices}}.": "次のサービスがロケーションにインストールされていることを確認してください: {{missingServices}}。",
	Version: Version,
	View: View,
	"View all": "すべて表示",
	"View audit events": "監査イベントの表示",
	"View docs": "資料の表示",
	"View error information": "エラー情報の表示",
	"View logging": "ログを見る",
	"View-only mode": "表示専用モード",
	"VPC Gen1": "VPC Gen1",
	"VPC Gen2": "VPC Gen2",
	Warning: Warning,
	"warning state": "警告状態",
	"Washington DC": "ワシントン DC",
	Wednesday: Wednesday,
	"What you will need:": "必要な内容:",
	"What's the purpose of this project?": "このプロジェクトの目的は何ですか。",
	"When you delete the cluster, all worker nodes, apps, and containers are permanently deleted. This action cannot be undone. Before you proceed, make sure to back up all required data and configuration files.": "クラスターを削除すると、すべてのワーカー・ノード、アプリ、およびコンテナーが完全に削除されます。 この操作は元に戻せません。 先に進む前に、必要なすべてのデータおよび構成ファイルをバックアップしてください。",
	"Worker count": "ワーカーの数",
	Workloads: Workloads,
	"Wrong Syntax": "構文が正しくありません",
	Yes: Yes,
	"You already have a location with this name. Enter a unique name.": "この名前のロケーションが既に存在します。 固有の名前を入力します。",
	"You already have an instance of Security and Compliance Center. To see results, you must schedule your first scan by creating an attachment.": "Security and Compliance Centerのインスタンスは既に存在します。 結果を表示するには、添付ファイルを作成して最初のスキャンをスケジュールする必要があります。",
	"You are unable to modify this policy due to your level of access for the policy's resource. If you'd like the ability to modify, contact your administrator to update your resource access.": "ポリシーのリソースに対するアクセス権限のレベルが原因で、このポリシーを変更することはできません。 変更する機能が必要になった場合は、管理者に連絡してリソース・アクセス権限を更新してもらってください。",
	"You can find a list of resources here once you create them.": "リソースを作成すると、ここにリソースのリストが表示されます。",
	"You can find your resource details here after you create them.": "リソースの詳細は、作成後にここに表示されます。",
	"You can find your resources here after you create them.": "リソースを作成すると、ここに表示されます。",
	"You can find your Satellite locations here after you create them.": "サテライトのロケーションは、作成後にここで確認できます。",
	"You do not have access to any resource groups.": "リソース・グループへのアクセス権限がありません。",
	"You do not have access to any resource groups. <a>Create</a> a resource group.": "リソース・グループへのアクセス権限がありません。 リソースグループを<a>作成</a>します。",
	"You do not have permission to edit tags. Contact your administrator if you require greater access.": "タグを編集する権限がありません。 より大きなアクセス権限が必要な場合は、管理者に連絡してください。",
	"You don't have the correct access to add a configuration in \"{{project}}\"": "「{{project}}」に設定を追加するための正しいアクセス権がありません",
	"You have restricted access and may not be able to add or remove tags. Contact your administrator if you require greater access.": "アクセスが制限されているため、タグを追加または削除できない可能性があります。 より大きなアクセス権限が必要な場合は、管理者に連絡してください。",
	"You haven't connected an Event Notifications service instance yet.": "Event Notifications サービス・インスタンスにまだ接続していません。",
	"You may also <a>create an instance</a>.": "<a>インスタンスを作成</a>することもできます。",
	"You may also create a new one.": "新規に作成することもできる。",
	"You may have context-based restrictions or IAM policies enabled. Contact your account administrator.": "コンテキスト・ベースの制限または IAM ポリシーが有効になっている可能性があります。 アカウント管理者にお問い合わせください。",
	"You must have at least one active root key. Try creating a new one.": "少なくとも 1 つのアクティブ・ルート鍵が必要です。 新しいものを作ってみてください。",
	"You need at least 1 topic to send a test notification.": "テスト通知を送信するには、少なくとも1 つのトピックが必要です。",
	"You need the Editor or Administrator role on the IBM Cloud Projects service to this project. <a>Assign yourself access</a> or request access from your account administrator.": "このプロジェクトに対する IBM Cloud プロジェクト・サービスに対するエディターまたは管理者の役割が必要です。 <a>自分にアクセス権限を割り当てる</a>か、アカウント管理者にアクセス権限を要求します。",
	"You're adding tags to:": "タグの追加先:",
	"You're editing tags for:": "編集するタグ:",
	"You're not authorized to connect to this instance. Verify your permissions or contact your administrator.": "このインスタンスに接続する権限がありません。 権限を確認するか、管理者に連絡してください。",
	"You're using the newest version of the API server. There are no updates available at this time.": "最新バージョンの API サーバーを使用しています。 現在使用可能な更新はありません。",
	"You've reached the maximum number of tags that you can attach at a single time. To attach more tags, save your changes first.": "1 回で付加できるタグの最大数に達しました。 さらにタグを付加するには、まず変更を保存してください。",
	"Your API server is updating to version {{version}}. After it finishes you can update your worker nodes to the same version.": "API サーバーがバージョン {{version}} に更新されています。 完了したら、ワーカー・ノードを同じバージョンに更新できます。",
	Zone: Zone,
	Zones: Zones,
	"Zoom in image": "イメージのズームイン",
	"Zoom out image": "イメージのズームアウト"
};

export { About, Access, Account, Actions, Active, Add, Address, Advanced, Aliases, All, Apply, April, Arbitrary, Assign, August, BNPP_EU, Back, Basic, CLI, Cancel, Category, Classic, Clear, Close, Clusters, Complete, Completed, Compliance, Compliant, Configuration, Configure, Confirm, Connect, Connected, Connecting, Containers, Country, Create, Created, Creating, Critical, Current, Custom, Dallas, Datacenter, Datacenters, December, Delete, Deleting, Deploying, Disabled, Disconnect, Docs, Documentation, Done, Download, Draft, Edit, Enabled, Encryption, End, Enterprise, Establish, Expired, Failed, February, Filter, Filters, Finalizing, Frankfurt, Free, Friday, Geography, Help, Hour, IAM, ID, Images, Inactive, Incomplete, Information, Infrastructure, Instance, Instances, Integrations, Invalid, January, July, June, Key, Launch, Lite, Loading, Location, Locations, Logging, London, March, May, Metro, Minute, Monday, Monitoring, Month, Name, Namespace, Namespaces, Next, No, None, Normal, Note, Notification, November, OK, Objects, October, Off, On, Open, Osaka, Overview, Packages, Pattern, Pending, Plan, Premium, Previous, Product, Products, Project, Projects, Property, Provider, Provisioning, Ready, Refresh, Region, Remove, Renew, Repositories, Requested, Required, Reservations, Reset, Resources, Results, Review, Routing, Satellite, Saturday, Save, Scanning, Schedule, Search, Secret, Select, Sending, September, Serverless, Service, Settings, Size, Sort, Source, Start, State, Status, Storage, Submit, Subscription, Success, Summary, Sunday, Sydney, Tags, Thursday, Tokyo, Topics, Toronto, Total, Trash, Trial, Tuesday, Unknown, Unsupported, Update, Upgrade, Value, Values, Version, View, Warning, Wednesday, Workloads, Yes, Zone, Zones, all, code, ja as default, hour, hr, mo, more, provided, region, resources, tag, tags };
